// src/styles/layoutStyles.js

const layoutStyles = {
    container: {
      padding: "30px",
      background: "#f5f7fb",
      minHeight: "100vh",
      fontFamily: "Arial, sans-serif",
    },
  
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "20px",
    },
  
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
      gap: "20px",
    },
  
    sectionTitle: {
      marginTop: "20px",
      marginBottom: "10px",
    },
  };
  
  export default layoutStyles;